import PersonType from '@/classes/facturae/PersonType'
import ResidenceType from '@/classes/facturae/ResidenceType'
import Issuer from '@/classes/facturae/Issuer'
import TaxWithHeld from '@/classes/facturae/TaxWithHeld'
import InvoiceLine from '@/classes/facturae/InvoiceLine'
import Descuento from '@/classes/facturae/Descuento'
import Tax from '@/classes/facturae/Tax'
import SimplificadaData from '@/classes/facturae/SimplificadaData'

import convertFileToBase64 from '@/services/functions/convertFileToBase64'
import getNullableNumber from '@/services/functions/getNullableNumber'

async function getPayloadSimplificada (form, { includeFiles = true, overrideTemplate = null } = {}) {
  const payload = new SimplificadaData()
  payload.serieFactura = form.serieFactura || null
  payload.numFactura = form.numFactura || null
  payload.dateEmision = form.dateEmision || null
  payload.albaran = form.albaran || null
  payload.pedido = form.pedido || null
  payload.tipoImpuestoFactura = form.tipoImpuestoFactura || null
  payload.observaciones = form.observaciones || null
  payload.numExpediente = form.numExpediente || null
  payload.dateExpediente = form.dateExpediente || null
  payload.numEmisor = form.numEmisor || null
  payload.dateEmisor = form.dateEmisor || null
  payload.codAsignacion = form.codAsignacion || null
  payload.dateReceptor = form.dateReceptor || null
  payload.dir3 = form.dir3 || null
  payload.numContrato = form.numContrato || null
  payload.codDepReceptor = form.codDepReceptor || null
  payload.cuotaSuplido = form.cuotaSuplido || null
  payload.periodoDesde = form.periodoDesde || null
  payload.periodoHasta = form.periodoHasta || null
  //   payload.tipoAsociado = form.tipoAsociado || null // TODO -> ¿Qué es?
  //   payload.fechaAplicacion = form.fechaAplicacion || null // TODO -> ¿Qué es?
  payload.idPlantilla = (overrideTemplate || form.template)?.idPlantilla || null

  if (form.issuer) {
    const formIssuer = form.issuer
    const issuer = new Issuer()
    issuer.Direccion = formIssuer.Direccion || null
    issuer.Poblacion = formIssuer.Poblacion || null
    issuer.CodigoPostal = formIssuer.CodigoPostal || null
    issuer.Provincia = formIssuer.Provincia || null
    issuer.CodigoPais = formIssuer.CodigoPais || null
    issuer.Telefono = formIssuer.Telefono || null
    issuer.EmailTecnico = formIssuer.EmailTecnico || null
    issuer.certAsociado = formIssuer.certAsociado || null
    issuer.RazonSocial = formIssuer.RazonSocial || null
    issuer.PersonaFisicaNombre = formIssuer.PersonaFisicaNombre || null
    issuer.PersonaFisicaPrimerApellido = formIssuer.PersonaFisicaPrimerApellido || null
    issuer.PersonaFisicaSegundoApellido = formIssuer.PersonaFisicaSegundoApellido || null
    issuer.CIF = formIssuer.CIF || null
    issuer.PersonaFisica = formIssuer.PersonaFisica ? PersonType.FISICA : PersonType.JURIDICA
    issuer.TipoResidencia = formIssuer.TipoResidencia || ResidenceType.RESIDENTE   
    payload.issuer = issuer
  }

  if (form.irpf) {
    const formIrpf = form.irpf
    const taxWithHeld = new TaxWithHeld()
    taxWithHeld.taxType = formIrpf.TaxType || '04'
    taxWithHeld.taxRate = getNullableNumber(formIrpf.TaxRate)
    payload.taxesWithHeld = taxWithHeld
  }

  if (form.invoiceLines?.length) {
    const formLines = form.invoiceLines
    payload.invoiceLines = []
    formLines.forEach(invoiceLine => {
      const line = new InvoiceLine()
      line.codProducto = invoiceLine.codProducto || null
      line.descripcion = invoiceLine.descripcion || null
      line.precioUnitario = getNullableNumber(invoiceLine.precioUnitario)
      line.cantidad = getNullableNumber(invoiceLine.cantidad)
      line.subtotal = getNullableNumber(invoiceLine.subtotal)
      line.total = getNullableNumber(invoiceLine.total)
      line.UnitOfMeasure = getNullableNumber(invoiceLine.UnitOfMeasure)
      line.totalConImpuesto = getNullableNumber(invoiceLine.totalConImpuesto)
      line.lineNumber = getNullableNumber(invoiceLine.lineNumber)
      if (invoiceLine.descuentos?.length) {
        const formDescuento = invoiceLine.descuentos[0]
        const descuento = new Descuento()
        descuento.descuento = (formDescuento.incluyeDescuento ? formDescuento.descuento : null) || null
        descuento.cuota = (formDescuento.incluyeDescuento ? null : formDescuento.cuota) || null
        if (formDescuento.incluyeDescuento ? (descuento.descuento || descuento.descuento === 0) : (descuento.cuota || descuento.cuota === 0)) {
          line.descuentos = descuento
        }
      }
      if (invoiceLine.taxes?.length) {
        const formTaxes = invoiceLine.taxes
        line.taxes = []
        formTaxes.forEach(lineTax => {
          const tax = new Tax()
          tax.taxType = lineTax.TaxType || null
          tax.taxRate = getNullableNumber(lineTax.TaxRate)
          tax.cuota = getNullableNumber(lineTax.cuota)
          line.taxes.push(tax)
        })
      }
      line.AdditionalLineItemInformation = invoiceLine.additionalLineItemInformation || null
      payload.invoiceLines.push(line)
    })
  }

  if (includeFiles) {
    const checkFile = form.file?.[0] ?? form.file
    if (checkFile && !Array.isArray(checkFile)) {
      payload.file = await convertFileToBase64(checkFile)
    }
    if (form.Adjuntos?.length) {
      payload.Adjuntos = await Promise.all(form.Adjuntos.map(file => convertFileToBase64(file)))
    }
  }
  return payload
}

export default getPayloadSimplificada
